import AxiosService from '@/api/ApiBase';
import { AirHblEntity } from '@/types/air/hbl/air-hbl.entity';
import { VirtualSearchPayload, VirtualSearchResponse } from '@/types/virtual-search';
import { RejectionPayload } from '@/types/hbl/pdf/rejection.entity';
import { RestoreService } from '@/types/service/restore.service';
import { AirHblMutatePayload, CreateEmptyAirHBLPayload } from '@/types/air/hbl';
import { HblExchangePalletsPayload } from '../house.service';
import { DuplicationPayload } from '../transload.service';

const AIR_HOUSE_BASE_URL = 'cfs/air/airhbl';

// const AIR_HOUSE_BASE_URL = 'http://10.142.0.4:7024/airhbl';
class AirHouseService implements RestoreService {
  virtualSearch(payload: VirtualSearchPayload<AirHblEntity>) {
    return AxiosService.post<VirtualSearchResponse<AirHblEntity>>(
      `${AIR_HOUSE_BASE_URL}/search`,
      payload
    );
  }
  restore(id: string) {
    return AxiosService.put<string>(`${AIR_HOUSE_BASE_URL}/restore/${id}`, {});
  }
  get(id: string) {
    return AxiosService.get<AirHblEntity>(`${AIR_HOUSE_BASE_URL}/details/${id}`);
  }
  getMilestones(id: string) {
    return AxiosService.get(`${AIR_HOUSE_BASE_URL}/milestones/${id}`);
  }
  async getHbsByMblId(mblId: string, sortOptions?: VirtualSearchPayload['sortBy']) {
    const {
      data: { items },
    } = await this.virtualSearch({
      mblId: [mblId],
      chunkSize: 50,
      ...(sortOptions ? { sortBy: sortOptions } : {}),
    });
    return items;
  }
  update(data: AirHblMutatePayload, id: string) {
    return AxiosService.patch(`${AIR_HOUSE_BASE_URL}/update/${id}`, data);
  }
  create(data: AirHblMutatePayload) {
    return AxiosService.post(`${AIR_HOUSE_BASE_URL}/create`, data);
  }
  createEmptyHBL(payload: CreateEmptyAirHBLPayload) {
    return AxiosService.post(`${AIR_HOUSE_BASE_URL}/copy`, payload);
  }
  clone(data: DuplicationPayload) {
    return AxiosService.post(`${AIR_HOUSE_BASE_URL}/clone`, data);
  }
  delete(id: string) {
    return AxiosService.delete(`${AIR_HOUSE_BASE_URL}/delete/${id}`);
  }
  getDefaultValues(mblId: string) {
    return AxiosService.get<Partial<AirHblEntity>>(`${AIR_HOUSE_BASE_URL}/defaultValues`, {
      params: {
        mblId,
      },
    });
  }
  createRejectionNotice(payload: RejectionPayload) {
    return AxiosService.post<AirHblEntity>(`${AIR_HOUSE_BASE_URL}/rejectionNotice`, payload);
  }
  removeRejectionNotice(id: string) {
    return AxiosService.delete<AirHblEntity>(`${AIR_HOUSE_BASE_URL}/rejectionNotice`, {
      params: { id },
    });
  }
  exchangePalletsResolved(payload: HblExchangePalletsPayload) {
    return AxiosService.patch<{ msg: string; releasedNotes: string }>(
      `${AIR_HOUSE_BASE_URL}/exchangePalletResolved`,
      payload
    );
  }

  releaseHbls(ids: string[]) {
    return AxiosService.post(`${AIR_HOUSE_BASE_URL}/release`, { ids });
  }
}

export default new AirHouseService();

export type AirHblsReleaseValidationResponse =
  | Record<
      string,
      {
        releaseStatus: false;
        availableDate: true;
        customReleased: false;
        customReleasedBy: false;
        customReleasedDate: false;
        frieghtReleased: false;
        cargoHold: false;
        markHold: false;
        inventoryLocation: false;
        isDeliveryOrderAvailable: false;
        charges: true;
        creditHold: true;
      }
    >
  | {
      message: string;
      status: number;
      code: string;
    };
